document.addEventListener('DOMContentLoaded', () => {
  const menus = document.querySelectorAll('.menu-dropdown');

  function handleOpen(event) {
    const menu = event.currentTarget.closest('.menu-dropdown');
    menu.classList.toggle('menu-dropdown--open');
  }

  function handleSelect() {
    document.querySelectorAll('.menu-dropdown__item').forEach(item => item.classList.remove('menu-dropdown__item--selected'));

    const target = window.location.pathname;
    const hash = decodeURIComponent(window.location.hash);
    const hashTarget = hash.length === 0 ? undefined : hash;

    const elementTarget = document.querySelectorAll(
      `.menu-dropdown__content a[href="${hashTarget || target}"]`
    );

    document.querySelectorAll('.menu-dropdown__selected').forEach(selected => {
      selected.innerText = elementTarget.length ? elementTarget[0].textContent : 'Selecione';
    });

    if (elementTarget.length === 0) return;

    elementTarget.forEach(item => item.classList.add('menu-dropdown__item--selected'));
  }

  function handleScroollTo(event) {
    event.preventDefault();
  
    const target = event.currentTarget.getAttribute('href');
    if (!target.startsWith('#') || target === '#') {
      window.location.href = target;
      return;
    }
  
    const element = document.getElementById(target.replace(/^#/, ''));
    if (!element) return;
  
    const offset = element.offsetTop - 100;
  
    window.location.hash = target;
    window.scrollTo({
      top: offset,
      behavior: 'smooth',
    });
  }


  menus.forEach(menu => {
    const selected = menu.querySelector('.menu-dropdown__selected');
    if (selected) {
      selected.addEventListener('click', handleOpen);
    }
  });

  handleSelect();
  window.addEventListener('hashchange', handleSelect, false);
  document.querySelectorAll('.menu-dropdown__content a').forEach(item => {
    item.addEventListener('click', handleScroollTo);
  });
});
